import { AppBuildInfo } from "app/types/logging.types";

const UNKNOWN_BUILD_VALUE = "unknown";

const firstDefined = (...values: Array<string | undefined>): string =>
  values.find((value) => Boolean(value?.trim())) || UNKNOWN_BUILD_VALUE;

export const getAppBuildInfo = (): AppBuildInfo => ({
  version: firstDefined(
    process.env.REACT_APP_VERSION,
    process.env.REACT_APP_APP_VERSION
  ),
  buildSha: firstDefined(
    process.env.REACT_APP_BUILD_SHA,
    process.env.REACT_APP_COMMIT_SHA,
    process.env.REACT_APP_GIT_SHA
  ),
  environment: process.env.REACT_APP_ENVIRONMENT,
});
